import type { EventAddress } from '@sportninja/common/features/event/types'

/**
 * A country/province may arrive as a bare string OR as a relation object
 * (`{ id, name, name_full, … }`) depending on the endpoint — the event detail
 * response switched to objects. Normalize both, and ignore anything else
 * rather than throwing: a display helper must never break the page it renders.
 */
export const toText = (value: unknown): string => {
  if (typeof value === 'string') {
    return value.trim()
  }
  if (value && typeof value === 'object') {
    const named = value as { name?: unknown; name_full?: unknown }
    if (typeof named.name === 'string') {
      return named.name.trim()
    }
    if (typeof named.name_full === 'string') {
      return named.name_full.trim()
    }
  }
  return ''
}

/**
 * Single-line address string. Missing parts are skipped so no stray commas
 * appear. Returns '' when there is nothing to show.
 */
export const formatEventAddress = (address: EventAddress | null): string => {
  if (!address) {
    return ''
  }
  return [
    address.street_1,
    address.street_2,
    address.city,
    address.province,
    address.postal_code,
    address.country,
  ]
    .map(toText)
    .filter(Boolean)
    .join(', ')
}
